import { render, staticRenderFns } from "./CiInfoBox.vue?vue&type=template&id=3b222eef&scoped=true"
import script from "./CiInfoBox.vue?vue&type=script&lang=js"
export * from "./CiInfoBox.vue?vue&type=script&lang=js"
import style0 from "./CiInfoBox.vue?vue&type=style&index=0&id=3b222eef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b222eef",
  null
  
)

export default component.exports